import React from "react";
import { AnalyticsBranchesResponse } from "../../../api/v2/types";

interface AnalyticsBranchActivityPanelProps {
  branches: AnalyticsBranchesResponse | null;
}

const AnalyticsBranchActivityPanel = ({ branches }: AnalyticsBranchActivityPanelProps) => {
  const items = branches?.branches || [];
  if (!items.length) return <p className="text-sm text-muted-foreground">No branch activity data.</p>;

  return (
    <div className="rounded border p-3">
      <p className="mb-2 text-sm font-semibold">Branch activity</p>
      <div className="space-y-1">
        {items.map((item) => (
          <div key={item.branch} className="grid grid-cols-5 gap-2 rounded border p-2 text-xs">
            <span className="font-medium">{item.branch}</span>
            <span>save: {item.saveCount}</span>
            <span>publish: {item.publishCount}</span>
            <span>{item.isWorkingBranch ? "working" : "-"}</span>
            <span>{item.isDefaultBranch ? "default" : "-"}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnalyticsBranchActivityPanel;
